module.exports = __webpack_public_path__ + "static/media/header-home.27c041aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/header-home.png
// module id = 338
// module chunks = 0